import React from 'react'
import { ActionIcon } from '@mantine/core'

function Icon({ width, height, color = 'currentColor' }) {
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      className="design-iconfont"
    >
      <path
        d="M1.171875,13.7480469 C0.52734375,13.7480469 0,13.2207031 0,12.5761719 L0,7.421875 C0,6.77734375 0.52734375,6.25 1.171875,6.25 L3.75,6.25 L10.9472656,1.80664062 C11.3378906,1.56640625 11.8417969,1.84570312 11.8417969,2.3046875 L11.8417969,17.6914062 C11.8398438,18.1503906 11.3378906,18.4296875 10.9472656,18.1894531 L3.75,13.7480469 L1.171875,13.7480469 Z M15.3066406,14.0117187 L17.8613281,16.5664062 C18.2148438,16.9199219 18.2148438,17.4980469 17.8613281,17.8515625 C17.5078125,18.2050781 16.9296875,18.2050781 16.5761719,17.8515625 L14.0214844,15.296875 C13.6679688,14.9433594 13.6679688,14.3652344 14.0214844,14.0117187 C14.375,13.6582031 14.953125,13.6582031 15.3066406,14.0117187 Z M19.0917969,9.0703125 C19.5917969,9.0703125 20,9.47851562 20,9.97851562 C20,10.4785156 19.5917969,10.8867187 19.0917969,10.8867187 L15.4785156,10.8867187 C14.9785156,10.8867187 14.5703125,10.4785156 14.5703125,9.97851562 C14.5703125,9.47851562 14.9785156,9.0703125 15.4785156,9.0703125 L19.0917969,9.0703125 Z M16.5371094,2.19335937 C16.890625,1.83984375 17.46875,1.83984375 17.8222656,2.19335937 C18.1757812,2.546875 18.1757812,3.125 17.8222656,3.47851562 L17.8222656,3.47851562 L15.2675781,6.03320312 C14.9140625,6.38671875 14.3359375,6.38671875 13.9824219,6.03320312 C13.6289062,5.6796875 13.6289062,5.1015625 13.9824219,4.74804687 L13.9824219,4.74804687 Z"
        fill="#00A870"
        fill-rule="nonzero"
      />
    </svg>
  )
}

const NoticeIcon = (props) => {
  const {
    fill = 'blue',
    variant = 'transparent',
    size = 'lg',
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <Icon width={width} height={height} />
    </ActionIcon>
  )
}

export default NoticeIcon
